var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68661 6.81334L6.31328 10.1867C5.87995 9.75334 5.61328 9.16001 5.61328 8.50001C5.61328 7.18001 6.67995 6.11334 7.99995 6.11334C8.65995 6.11334 9.25328 6.38001 9.68661 6.81334Z",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8799 4.34666C10.7132 3.46666 9.3799 2.98666 7.9999 2.98666C5.64656 2.98666 3.45323 4.37333 1.92656 6.77333C1.32656 7.71333 1.32656 9.29333 1.92656 10.2333C2.45323 11.06 3.06656 11.7733 3.73323 12.3467",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 13.52C6.37328 13.84 7.17995 14.0133 7.99995 14.0133C10.3533 14.0133 12.5466 12.6267 14.0733 10.2267C14.6733 9.28665 14.6733 7.70665 14.0733 6.76665C13.8533 6.41998 13.6133 6.09332 13.3666 5.78665",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3409 8.96667C10.1676 9.90667 9.40094 10.6733 8.46094 10.8467",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31203 10.1867L1.33203 15.1667",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6675 1.83334L9.6875 6.81334",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.ce97a83a90e1bdae6542f9e976594afa.svg";
export { ForwardRef as ReactComponent };